import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { inputBorderColor, inputRadius } from "#app/theme/v2/inputStates";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import {
  formatDurationLabel,
  parseDurationFormula,
} from "#modules/onboardingV2/domain/durationFormula";
import { Icon } from "#shared/icons/Icon";

type DurationCellProps = {
  value: string | null;
  editable: boolean;
  title: string;
  onOpen: () => void;
};

export const DurationCell = ({ value, editable, title, onOpen }: DurationCellProps) => {
  const { t } = useTranslation();

  const label = !editable
    ? "--"
    : value === null
      ? t("onboardingV2.processStepConfiguration.autoEstimation")
      : formatDurationLabel(parseDurationFormula(value));

  const textColor = editable ? colors.text.primaryDefault : colors.text.secondaryDisabled;
  const iconColor = editable ? colors.icon.primaryDefault : colors.icon.primaryDisabled;

  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: spacing[2],
        borderRadius: inputRadius,
        border: `1px solid ${editable ? inputBorderColor : colors.border.secondaryDisabled}`,
        background: colors.bg.elevation.primary,
      }}
    >
      <Box style={{ flex: 1, minWidth: 0, paddingInline: spacing[1] }}>
        <Text size="small" color={textColor} truncate>
          {label}
        </Text>
      </Box>
      <Box
        component="button"
        type="button"
        disabled={!editable}
        onClick={onOpen}
        aria-label={title}
        style={{
          display: "flex",
          alignItems: "center",
          paddingInline: spacing[0.5],
          background: "none",
          border: "none",
          cursor: editable ? "pointer" : "default",
        }}
      >
        <Icon name="pencil" size={12} color={iconColor} />
      </Box>
    </Box>
  );
};
